import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  spinner: {
    top: '0px',
    left: 'auto',
    marginLeft: 12,
    color: 'white'
  }
}))

export default useStyles
